import axios from 'axios';
import { useQuery } from 'react-query';

const useGetIdCardByTagId = (tagId) => {
  const { data, isLoading } = useQuery(
    ['idCardByTagId', { tagId }],
    async () => {
      return (
        await axios.get(`/idcards/byTagId/${tagId}`, {
          timeout: 20000,
        })
      ).data;
    },
    {
      enabled: tagId !== undefined,
      refetchOnMount: Boolean(tagId),
    }
  );

  return {
    idCard: data,
    isLoading,
  };
};

export default useGetIdCardByTagId;
